const USER_PERMISSIONS = {
  EPISODES: 'episodes',
  PARTNER_ANALYTICS: 'partneranalytics',
  VIDEO_ADMIN: 'videoadmin',
  VIDEO_REQUEST: 'videorequest',
  EPISODE_FEED_URL: 'episodefeedurl',
};

module.exports = USER_PERMISSIONS;
